/* ==========================================================================
   AirSeat25 広告LP スクリプト
   Shopify theme assets/ に配置。テーマ側では以下で読み込む：
     <script src="{{ 'airseat25-lp.js' | asset_url }}" defer></script>

   注意：defer属性により、このスクリプトはDOM解析完了後・DOMContentLoaded
   発火前に実行される。そのためDOMContentLoadedラッパーは不要（むしろ、
   ラップすると toggleAccordion() / playInstallVideo() / scrollToId() /
   trackEvent() がグローバルスコープから外れ、HTML側の
   onclick="toggleAccordion(this)" 等のインラインハンドラから参照できなくなり
   動作しなくなるため、意図的にラップしていない）。
   ========================================================================== */

  /* =========================================================
     計測イベント（Meta Pixel / GA4 実送信 実装済み）
     trackEvent() は window.fbq / window.gtag が読み込まれていれば
     それぞれへ実送信する。Shopifyページ側でMeta Pixelベースコードと
     GA4のgtag.jsを先に読み込んでおけば、そのまま送信される。
     fbq/gtagが未読み込みの開発・プレビュー環境では console.log にフォールバック。

     広告最適化との関係：
     - Meta広告キャンペーンの最適化目標はあくまで Purchase のまま。
     - lp_view / scroll_50 / video_play / fitcheck_start / fitcheck_complete は
       中間KPI・分析用のカスタムイベントであり、Purchaseの最適化目標の代わりにはしない。
     - cta_click と product_page_transition は商品ページ遷移の計測用。

     Shopify側との接続：
     - このLPはあくまで商品ページ手前の広告用ページであり、実際の
       AddToCart / InitiateCheckout / Purchase はShopify商品ページ・
       チェックアウト側の既存Pixel/GA4実装で計測される想定。
     - このLP側では、上記イベントを「Purchaseに至るまでの手前の行動」
       として送信し、Shopify側の AddToCart 以降のイベントと合わせて
       ファネル全体（LP View → Fit Check → 商品ページ遷移 → AddToCart →
       InitiateCheckout → Purchase）を一つの広告アカウント内で追える
       状態にする。LP側で AddToCart / InitiateCheckout / Purchase 自体を
       重複送信しない。

     公開前に必要な設定（このLP側の実装ではなく、Shopify側の作業）：
     - Meta Pixel ID を発行しベースコードをShopifyテーマに追加
     - GA4 測定IDを発行しgtag.jsをShopifyテーマに追加
  ========================================================= */
  function trackEvent(name, params){
    params = params || {};
    // Meta Pixel
    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', name, params);
    }
    // GA4
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
    // Local fallback so events remain visible during development/testing
    // even before fbq/gtag are loaded on the real Shopify page.
    if (typeof window.fbq !== 'function' && typeof window.gtag !== 'function') {
      console.log('[track]', name, params);
    }
  }

  trackEvent('lp_view');

  // ---- 50% scroll ----
  let scrolledHalf = false;
  window.addEventListener('scroll', function(){
    const scrolled = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
    if(!scrolledHalf && scrolled > 0.5){
      scrolledHalf = true;
      trackEvent('scroll_50');
    }
  });

  // ---- sticky CTA visibility ----
  // 表示条件：FVを通過している AND 最終オファーセクションが画面内に入っていない
  // AND 最終オファーを「下方向に」通過し終えていない。
  //
  // 最終オファー内にも同じ「購入する」系CTAが大きく表示されるため、そこでは
  // 固定CTAを一時的に隠し、二重表示を防ぐ。さらに、最終オファーを一度
  // 下方向へ通過した後は、保証セクション・LPフッターまで進んでも固定CTAを
  // 再表示しない（ページ終盤をすっきり見せるため）。ユーザーが上へスクロールし
  // 最終オファーより上に戻った場合のみ、通常のFV基準の表示制御に復帰する。
  //
  // 実装方法：offerセクションについては、IntersectionObserverの「交差状態が
  // 変化した瞬間」のイベントだけに頼らず、スクロールのたびに現在の
  // getBoundingClientRect()を直接再計算する。IntersectionObserverはイベント
  // 駆動のため、アンカーリンクや scrollIntoView 等で画面外から画面外へ
  // 一気にジャンプした場合、中間の「交差した瞬間」を検知できず状態が
  // 更新されないことがある。スクロール位置から毎回直接判定することで、
  // どのような移動経路でも常に正しい状態になる。
  const fv = document.getElementById('fv');
  const offerSection = document.getElementById('offer');
  const stickyCta = document.getElementById('stickyCta');
  let pastFv = false;
  let offerInView = false;
  let passedOfferDownward = false;

  function updateStickyCtaVisibility(){
    stickyCta.classList.toggle('show', pastFv && !offerInView && !passedOfferDownward);
  }

  const fvObserver = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      pastFv = !e.isIntersecting;
      updateStickyCtaVisibility();
    });
  }, {threshold:0});
  fvObserver.observe(fv);

  if(offerSection){
    let offerTicking = false;
    function updateOfferState(){
      const rect = offerSection.getBoundingClientRect();
      const vh = window.innerHeight;
      // 画面内に15%以上重なっていれば「表示中」とみなす（旧threshold:0.15相当）
      const visibleTop = Math.max(rect.top, 0);
      const visibleBottom = Math.min(rect.bottom, vh);
      const visibleRatio = Math.max(0, visibleBottom - visibleTop) / Math.min(rect.height, vh);
      offerInView = visibleRatio >= 0.15;

      // passedOfferDownward は「オファーセクションの中心点が画面上端(0)より
      // 上にあるか」という単一の連続比較で判定する。二つの片側条件
      // （rect.bottom<0 と rect.top>vh）を別々に使うと、その間に
      // 「どちらにも該当しない一瞬の隙間」が生じ、scrollIntoView等の
      // ジャンプ移動でちょうどその隙間に着地すると状態が更新されない
      // バグがあったため、単一の閾値に統一して隙間をなくしている。
      const offerMidpoint = (rect.top + rect.bottom) / 2;
      passedOfferDownward = offerMidpoint < 0;

      updateStickyCtaVisibility();
      offerTicking = false;
    }
    updateOfferState(); // 初期状態を反映
    window.addEventListener('scroll', ()=>{
      if(!offerTicking){
        offerTicking = true;
        requestAnimationFrame(updateOfferState);
      }
    }, {passive:true});
  }

  // ---- worry items fade-in ----
  const worryItems = document.querySelectorAll('.worry-item');
  const worryObserver = new IntersectionObserver((entries)=>{
    entries.forEach((e,i)=>{
      if(e.isIntersecting){
        setTimeout(()=>e.target.classList.add('visible'), i*80);
        worryObserver.unobserve(e.target);
      }
    });
  }, {threshold:0.3});
  worryItems.forEach(el=>worryObserver.observe(el));

  // ---- fit check ----
  const checkboxes = document.querySelectorAll('[data-check]');
  const checkResult = document.getElementById('checkResult');
  let fitStarted = false;
  checkboxes.forEach(cb=>{
    cb.addEventListener('change', function(){
      this.closest('.check-item').classList.toggle('checked', this.checked);
      if(!fitStarted){
        fitStarted = true;
        trackEvent('fitcheck_start');
      }
      const total = checkboxes.length;
      const checked = document.querySelectorAll('[data-check]:checked').length;
      if(checked === total){
        checkResult.classList.add('show');
        trackEvent('fitcheck_complete');
      } else {
        checkResult.classList.remove('show');
      }
    });
  });

  // ---- accordion ----
  function toggleAccordion(head){
    const item = head.closest('.accordion-item');
    item.classList.toggle('open');
  }

  // ---- muted decorative videos (short intro / tech loop): play only while
  // in view. This gives the "always moving" feel of an autoplay hero video
  // without wasting bandwidth/battery on off-screen content, and works on
  // iOS/Android without a tap because the videos are muted + playsinline.
  //
  // trackedVideoPlays guards against duplicate video_play sends: a user
  // scrolling back and forth re-triggers play()/pause() on every viewport
  // enter/exit, but each <video> should only ever report video_play once
  // per page session, on its first successful playback start. ----
  const inViewVideos = document.querySelectorAll('#videoFrame video, .tech-diagram video');
  const trackedVideoPlays = new Set();
  const videoInViewObserver = new IntersectionObserver((entries)=>{
    entries.forEach(entry=>{
      const v = entry.target;
      if(entry.isIntersecting){
        v.play().then(()=>{
          if(!trackedVideoPlays.has(v)){
            trackedVideoPlays.add(v);
            trackEvent('video_play', {id: v.dataset.videoId || 'unknown'});
          }
        }).catch(()=>{ /* autoplay blocked — video still has a visible poster frame */ });
      } else {
        v.pause();
      }
    });
  }, {threshold:0.5});
  inViewVideos.forEach(v=>videoInViewObserver.observe(v));

  // ---- install video (94s): tap-to-play, not autoplay ----
  // The play button is removed from the DOM entirely once tapped (see CSS:
  // .install-video-frame.is-playing .install-play-btn{display:none}), so
  // this function — and therefore its trackEvent call — can only ever run
  // once per page session; no separate dedup guard is needed here.
  function playInstallVideo(){
    const wrap = document.getElementById('installVideoFrame');
    const v = wrap.querySelector('video');
    v.setAttribute('controls', '');
    v.play();
    wrap.classList.add('is-playing');
    trackEvent('video_play', {id: v.dataset.videoId || 'install_video'});
  }

  function scrollToId(id){
    document.getElementById(id).scrollIntoView({behavior:'smooth'});
  }
